import { Component } from 'react';

interface RemoteBoundaryProps {
  children: React.ReactNode;
  name?: string;
}

interface RemoteBoundaryState {
  hasError: boolean;
}

class RemoteBoundary extends Component<RemoteBoundaryProps, RemoteBoundaryState> {
  state: RemoteBoundaryState = { hasError: false };

  static getDerivedStateFromError(): RemoteBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    const { name = 'Remote microfrontend' } = this.props;
    console.error(`${name} failed to render:`, error);
  }

  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return null;
    }

    return children;
  }
}

export default RemoteBoundary;
